"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function miniappRenderer(_a, _b) {
    var _c;
    var _d = _a.appConfig, appConfig = _d === void 0 ? {} : _d, createBaseApp = _a.createBaseApp, createHistory = _a.createHistory, staticConfig = _a.staticConfig, pageProps = _a.pageProps, emitLifeCycles = _a.emitLifeCycles, ErrorBoundary = _a.ErrorBoundary;
    var mount = _b.mount, unmount = _b.unmount, createElement = _b.createElement, Component = _b.Component;
    var history = createHistory({ routes: staticConfig.routes });
    var runtime = createBaseApp(appConfig).runtime;
    var AppProvider = (_c = runtime === null || runtime === void 0 ? void 0 : runtime.composeAppProvider) === null || _c === void 0 ? void 0 : _c.call(runtime);
    var _e = appConfig.app, app = _e === void 0 ? {} : _e;
    var _f = app.rootId, rootId = _f === void 0 ? 'root' : _f, ErrorBoundaryFallback = app.ErrorBoundaryFallback, onErrorBoundaryHander = app.onErrorBoundaryHander, onErrorBoundaryHandler = app.onErrorBoundaryHandler, errorBoundary = app.errorBoundary;
    if (onErrorBoundaryHander) {
        console.error('Please use onErrorBoundaryHandler instead of onErrorBoundaryHander');
    }
    emitLifeCycles();
    var App = /** @class */ (function (_super) {
        __extends(App, _super);
        function App() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        App.prototype.render = function () {
            var _a = this.props, Page = _a.Page, otherProps = __rest(_a, ["Page"]);
            var PageComponent = createElement(Page, __assign({}, otherProps));
            var appInstance = PageComponent;
            if (AppProvider) {
                appInstance = createElement(AppProvider, null, appInstance);
            }
            if (errorBoundary) {
                appInstance = createElement(ErrorBoundary, {
                    Fallback: ErrorBoundaryFallback,
                    onError: onErrorBoundaryHander || onErrorBoundaryHandler,
                }, appInstance);
            }
            return appInstance;
        };
        return App;
    }(Component));
    var pagesRenderInfo = staticConfig.routes.map(function (_a) {
        var source = _a.source, component = _a.component, pageSource = _a.pageSource;
        return {
            path: pageSource || source,
            render: function () {
                var PageComponent = component()();
                var rootEl = document.createElement('div');
                rootEl.setAttribute('id', rootId);
                var appInstance = mount(createElement(App, __assign(__assign({ history: history, location: history.location }, pageProps), { Page: PageComponent })), rootEl);
                document.body.appendChild(rootEl);
                document.__unmount = unmount(appInstance, rootEl);
            },
            setDocument: function (value) {
                // eslint-disable-next-line no-global-assign
                document = value;
                // getApp doesn't exist in plugin situation
                // @ts-ignore
                if (typeof getApp === 'function') {
                    // @ts-ignore
                    var MiniAppGlobalInstance = getApp();
                    var dispatchDocumentModify = MiniAppGlobalInstance._dispatchDocumentModify;
                    if (typeof dispatchDocumentModify === 'function') {
                        dispatchDocumentModify.call(MiniAppGlobalInstance, value);
                    }
                }
            }
        };
    });
    window.__pagesRenderInfo = (window.__pagesRenderInfo || []).concat(pagesRenderInfo);
}
exports.default = miniappRenderer;
